import clsx from 'clsx'
import { createStatusChip } from 'components/status-chip'
import { REQUEST_STATUS, STUDENT_STATUS_LABELS } from './utils'

// Golfer-facing wording for the same three backend states the coach sees.
const StudentStatusChip = createStatusChip({
  [REQUEST_STATUS.PURCHASED]: {
    label: STUDENT_STATUS_LABELS[REQUEST_STATUS.PURCHASED],
    color: 'warning',
  },
  [REQUEST_STATUS.READY_TO_ANALYZE]: {
    label: STUDENT_STATUS_LABELS[REQUEST_STATUS.READY_TO_ANALYZE],
    color: 'active',
  },
  [REQUEST_STATUS.COMPLETE]: {
    label: STUDENT_STATUS_LABELS[REQUEST_STATUS.COMPLETE],
    color: 'success',
  },
})

// Tints per state (nav grey, light blue, green; see `statusChip*` in
// styles.js). The list and the detail page both pass this as the chip's
// `className`, so they always agree. `classes` is `useStyles()`.
export const getStatusChipClassName = (classes, status) =>
  clsx(
    classes.statusChip,
    {
      [REQUEST_STATUS.PURCHASED]: classes.statusChipWarning,
      [REQUEST_STATUS.READY_TO_ANALYZE]: classes.statusChipActive,
      [REQUEST_STATUS.COMPLETE]: classes.statusChipSuccess,
    }[status],
  )

export default StudentStatusChip
